import { useMutation } from '@tanstack/react-query';
import { forgotPassword } from 'api/services/auth';
import { routesSettings } from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { ForgotPasswordPayload } from 'types/auth';
import ToastHelper from 'utils/toast';
import ForgotPasswordView from './ForgotPassword.view';

const ForgotPasswordContainer = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate(routesSettings.AUTH_LOGIN.path, {
      replace: true,
    });
  };

  const { mutate, isPending } = useMutation({
    mutationFn: (payload: ForgotPasswordPayload) => {
      return forgotPassword(payload);
    },
    onSuccess: (data) => {
      ToastHelper.success('Password reset link sent to your email');
      navigate(routesSettings.AUTH_LOGIN.path, {
        replace: true,
      });
    },
    onError: (error) => {
      ToastHelper.error('Email not found.');
      navigate(routesSettings.AUTH_LOGIN.path, {
        replace: true,
      });
    },
  });

  return (
    <ForgotPasswordView
      onSubmit={mutate}
      isLoading={isPending}
      goToLogin={goToLogin}
    />
  );
};

export default ForgotPasswordContainer;
